import { Widget, WIDGET_RESULTS_RETAIL } from "@gaming/srvg-classes-core";


export class ResultsRetailWidget extends Widget {
    widgetName: string;
    widget: any;

    constructor( options ) {

        options = options || {};
        options.selector = options.selector || '#resultsretailWidget';
        super( options );

        this.name = 'widgetmatrix';
        this.widgetName = options.widgetName || WIDGET_RESULTS_RETAIL;
        this.widgetName = this.product + this.widgetName;

        this.widget = null;
        this.widgetOptions = {
            height: this.getContainerHeightWithUnit()
        };
        this.mergeWidgetOptions(options);
    }

    handleDomInstantiated() {
        this.addResultsRetailWidget();
        super.handleDomInstantiated();
    }

    /**
     * add matrix widget to given selector (html element selector)
     * @param string selector html element selected (not element itself)
     */
    addResultsRetailWidget(selector?) {
        var that = this;
        selector = selector || this.selector;

        this.widget = this.addWidget(
            selector,
            this.widgetName,
            this.widgetOptions
        );
    }

    /**
     * add specific widget will be called by events for example, prepares eventdata and calls addResultsRetailWidget
     * @param string selector
     * @param object/any eventdata
     */
    addSpecificWidget(element, eventdata){
        this.addResultsRetailWidget(element);
    }



}